export default function getPositions(selectedFilesCount) {
  if (selectedFilesCount >= 1000) {
    return {
      width: 35,
      marginTop: 9,
      copy: {
        top: 35 - 12,
        left: 9 + 17
      }
    }
  }

  if (selectedFilesCount >= 100) {
    return {
      width: 27,
      marginTop: 5,
      copy: {
        top: 27 - 9,
        left: 5 + 14
      }
    }
  }
  if (selectedFilesCount >= 10) {
    return {
      width: 23,
      marginTop: 4,
      copy: {
        top: 22 - 6,
        left: 4 + 11
      }
    }
  }

  return {
    width: 20,
    marginTop: 2,
    copy: {
      top: 20 - 6,
      left: 2 + 10
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Media/DragLayer/getPositions.js